import React from 'react';

const frameworks = [
  { name: 'Spring Boot', role: 'Backend robusto para APIs REST', percent: 85, color: '#6db33f', icon: '🍃', tag: 'Backend' },
  { name: 'React',       role: 'Interfaces dinámicas y reactivas', percent: 90, color: '#61dafb', icon: '⚛️', tag: 'Frontend' },
  { name: 'Angular',     role: 'Framework empresarial completo',  percent: 70, color: '#dd0031', icon: '🅰️', tag: 'Frontend' },
  { name: 'Vue',         role: 'Framework progresivo y ligero',   percent: 75, color: '#42b883', icon: '💚', tag: 'Frontend' },
];

const features = [
  { icon: '⚡', title: 'Terminal SQL',       desc: 'Ejecuta CREATE TABLE, INSERT, SELECT directamente desde el navegador.', color: '#28a745' },
  { icon: '📝', title: 'Form Wizard',        desc: 'Genera tu CRUD completo de forma visual, sin escribir una sola línea de SQL.', color: '#ffc107' },
  { icon: '🌐', title: 'Remote Connection',  desc: 'Conecta OmniCrud a cualquier base de datos remota de forma segura.', color: '#ff0730' },
  { icon: '📦', title: 'Descargar Proyecto', desc: 'Exporta el proyecto generado listo para abrir en tu IDE favorito.', color: '#007bff' },
];

const Tutorial: React.FC = () => {
  return (
    <div className="tut-page fade-in">

      {/* ── DECORACIÓN LATERAL IZQUIERDA ── */}
      <aside className="tut-side tut-side-left" aria-hidden="true">
        <div className="tut-side-label">OMNICRUD</div>
        <div className="tut-side-dots">
          {Array.from({length: 12}).map((_, i) => <span key={i} className="tut-sdot" />)}
        </div>
        <div className="tut-side-icons">
          <span title="Base de datos">🗄️</span>
          <span title="API">🔌</span>
          <span title="Código">💻</span>
          <span title="Deploy">🚀</span>
        </div>
        <div className="tut-side-line" />
      </aside>

      {/* ── CONTENIDO CENTRAL ── */}
      <main className="tut-main">

        {/* HERO */}
        <div className="tut-hero">
          <div className="tut-hero-text">
            <span className="tut-badge">v1.0 · Guía de inicio</span>
            <h1 className="tut-hero-title">
              Bienvenido a <span className="tut-brand">OmniCrud</span>
            </h1>
            <p className="tut-hero-sub">
              Genera proyectos CRUD completos con los frameworks más usados del mercado.
              Sin configuración manual, sin perder tiempo.
            </p>
            <div className="tut-hero-stats">
              <div className="tut-stat"><span className="tut-stat-n">4</span><span className="tut-stat-l">Frameworks</span></div>
              <div className="tut-stat-sep" />
              <div className="tut-stat"><span className="tut-stat-n">2</span><span className="tut-stat-l">Lenguajes</span></div>
              <div className="tut-stat-sep" />
              <div className="tut-stat"><span className="tut-stat-n">∞</span><span className="tut-stat-l">Proyectos</span></div>
            </div>
          </div>
          <div className="tut-hero-visual">
            <div className="tut-code-block">
              <div className="tut-code-dots">
                <span style={{background:'#ff5f57'}}/>
                <span style={{background:'#febc2e'}}/>
                <span style={{background:'#28c840'}}/>
                <span className="tut-code-title">schema.sql</span>
              </div>
              <pre>{`CREATE TABLE usuarios (
  id      INT PRIMARY KEY,
  nombre  VARCHAR(100),
  email   VARCHAR(100)
);

-- ✅ Proyecto generado`}</pre>
            </div>
            {/* Chips flotantes */}
            <div className="tut-chip tut-chip-1">Spring Boot ☕</div>
            <div className="tut-chip tut-chip-2">React ⚛️</div>
            <div className="tut-chip tut-chip-3">Angular 🅰️</div>
          </div>
        </div>

        {/* QUÉ PUEDES HACER */}
        <div className="tut-section">
          <h2 className="tut-section-title">¿Qué puedes hacer con OmniCrud?</h2>
          <div className="tut-features-grid">
            {features.map((f) => (
              <div className="tut-feature-card" key={f.title}
                style={{'--accent': f.color} as React.CSSProperties}>
                <div className="tut-feature-icon">{f.icon}</div>
                <div className="tut-feature-body">
                  <h4 className="tut-feature-title">{f.title}</h4>
                  <p className="tut-feature-desc">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FRAMEWORKS */}
        <div className="tut-section">
          <h2 className="tut-section-title">Frameworks disponibles</h2>
          <div className="tut-fw-grid">
            {frameworks.map((fw) => (
              <div className="tut-fw-card" key={fw.name}
                style={{'--fw-color': fw.color} as React.CSSProperties}>
                <div className="tut-fw-header">
                  <span className="tut-fw-icon">{fw.icon}</span>
                  <div>
                    <div className="tut-fw-name">{fw.name}</div>
                    <span className="tut-fw-tag">{fw.tag}</span>
                  </div>
                  <span className="tut-fw-pct">{fw.percent}%</span>
                </div>
                <p className="tut-fw-role">{fw.role}</p>
                <div className="tut-fw-bar-track">
                  <div className="tut-fw-bar-fill"
                    style={{width: `${fw.percent}%`, background: fw.color}} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* PASOS */}
        <div className="tut-section">
          <h2 className="tut-section-title">¿Cómo empezar?</h2>
          <div className="tut-steps">
            {[
              { n:'01', title:'Elige tu framework',  desc:'Selecciona el lenguaje y arquitectura de tu proyecto.', color:'#007bff' },
              { n:'02', title:'Define tus tablas',   desc:'Usa el Form Wizard o escribe SQL en la Terminal.', color:'#28a745' },
              { n:'03', title:'Genera y descarga',   desc:'OmniCrud construye el proyecto listo para usar.', color:'#ffc107' },
            ].map((s, i) => (
              <div className="tut-step" key={s.n}
                style={{'--delay': `${i * 0.12}s`, '--sc': s.color} as React.CSSProperties}>
                <div className="tut-step-num" style={{color: s.color}}>{s.n}</div>
                <div className="tut-step-body">
                  <h4 className="tut-step-title">{s.title}</h4>
                  <p className="tut-step-desc">{s.desc}</p>
                </div>
                <div className="tut-step-arrow">→</div>
              </div>
            ))}
          </div>
        </div>

      </main>

      {/* ── DECORACIÓN LATERAL DERECHA ── */}
      <aside className="tut-side tut-side-right" aria-hidden="true">
        <div className="tut-side-line" />
        <div className="tut-tech-stack">
          <div className="tut-tech-card" style={{'--tc':'#6db33f'} as React.CSSProperties}>
            <span>🍃</span><small>Spring</small>
          </div>
          <div className="tut-tech-card" style={{'--tc':'#61dafb'} as React.CSSProperties}>
            <span>⚛️</span><small>React</small>
          </div>
          <div className="tut-tech-card" style={{'--tc':'#dd0031'} as React.CSSProperties}>
            <span>🅰️</span><small>Angular</small>
          </div>
          <div className="tut-tech-card" style={{'--tc':'#42b883'} as React.CSSProperties}>
            <span>💚</span><small>Vue</small>
          </div>
        </div>
        <div className="tut-side-progress">
          <div className="tut-sp-label">Popularidad</div>
          {frameworks.map(fw => (
            <div className="tut-sp-row" key={fw.name}>
              <span className="tut-sp-name">{fw.name.split(' ')[0]}</span>
              <div className="tut-sp-track">
                <div className="tut-sp-fill"
                  style={{width:`${fw.percent}%`, background: fw.color}} />
              </div>
            </div>
          ))}
        </div>
        <div className="tut-side-dots">
          {Array.from({length: 12}).map((_, i) => <span key={i} className="tut-sdot" />)}
        </div>
      </aside>

    </div>
  );
};

export default Tutorial;